import basePlan3 from 'moodleDir/procollege/lib/vue/default-block-root.vue';

export default {
  routes: [
    {
      path: '/',
      component:basePlan3,
      name:'basePlan3'
    },
  ]
};
